export enum RenderMode {
  PREVIEW = 'PREVIEW',
  PRINT = 'PRINT',
}
